module.exports = __webpack_public_path__ + "img/pica5.a0a3c443.png";